import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Skeleton from "@material-ui/lab/Skeleton";

const useStyles = makeStyles((theme) => ({
  root: {
    borderColor: "rgb(209,219,227)",
    borderWidth: "2px",
    padding: "4em 1em",
    marginBottom: "2em",
  },
  title: {
    margin: "1em 0 2em 0",
    backgroundColor: theme.palette.primary.main,
  },
}));

export default function BlogCard() {
  const classes = useStyles();
  return (
    <Card className={classes.root} variant="outlined">
      <CardContent>
        {/* Date text */}
        <Skeleton variant="text" width="15%" />
        {/* Title text */}
        <Skeleton className={classes.title} variant="text" width="35%" />
        {/* Body text  */}
        <Skeleton variant="text" width="85%" />
        <Skeleton variant="text" width="85%" />
        <Skeleton variant="text" width="85%" />
        <Skeleton variant="text" width="85%" />
        <Skeleton variant="text" width="85%" />
        <Skeleton variant="text" width="85%" />
        <Skeleton variant="text" width="85%" />
      </CardContent>
    </Card>
  );
}
